var en_us = {
    values: {
        datetime_format: 'mmmm dS, yyyy, h:MM:ss TT',
        'Invalid date': 'Invalid date',
        'JSON Configuration required': 'JSON Configuration required',
        'E-mail body is required': 'E-mail body is required',
        'Subject is required': 'Subject is required',
        'E-mail Subject': 'E-mail Subject',
        'E-mail Body': 'E-mail Body',
        'Query Configuration': 'Query Configuration',
        BLACK: 'BLACK',
        WHITE: 'WHITE',
        RED: 'RED',
        'BRIGHT GREEN': 'BRIGHT GREEN',
        BLUE: 'BLUE',
        YELLOW: 'YELLOW',
        PINK: 'PINK',
        TURQUOISE: 'TURQUOISE',
        'DARK RED': 'DARK RED',
        GREEN: 'GREEN',
        'DARK BLUE': 'DARK BLUE',
        'DARK YELLOW': 'DARK YELLOW',
        VIOLET: 'VIOLET',
        TEAL: 'TEAL',
        'GREY 25 PERCENT': 'GREY 25 PERCENT',
        'GREY 50 PERCENT': 'GREY 50 PERCENT',
        'CORNFLOWER BLUE': 'CORNFLOWER BLUE',
        MAROON: 'MAROON',
        'LEMON CHIFFON': 'LEMON CHIFFON',
        'LIGHT TURQUOISE1': 'LIGHT TURQUOISE1',
        ORCHID: 'ORCHID',
        CORAL: 'CORAL',
        'ROYAL BLUE': 'ROYAL BLUE',
        'LIGHT CORNFLOWER BLUE': 'PERIWINKLE',
        'Header Background Color': 'Header Background Color',
        'Header Font Color': 'Header Font Color',
        Result: 'Result',

        'Run and Monitor': 'Run and Monitor',
        'Instance status': 'Instance status',
        Schedule: 'Schedule',
        Disabled: 'Disabled',
        'Currently running': 'Currently running',
        Yes: 'Yes',
        No: 'No',
        'Running since': 'Running since',
        'Last run': 'Last run',
        'Not available': 'Not available',

        PENDING: 'Pending',
        RUNNING: 'Running',
        OK: 'Ok',
        ERROR: 'Error',

        'Execute now': 'Execute now',
        Refresh: 'Refresh',
        Close: 'Close',
        'Request successful. The execution will start in a few moments':
            'Request successful. The execution will start in a few moments',
        'The task is already running': 'The task is already running',
        'Available executor': 'Available executor',
        sectionTemplateActive: 'Active',
        'A expressão Lorem ipsum em design gráfico e editoração é um texto padrão em latim utilizado na produção gráfica para preencher os espaços de texto em publicações para testar e ajustar aspectos visuais antes de utilizar conteúdo real.':'The Lorem ipsum expression in graphic design and publishing is a standard Latin text used in graphic production to fill in text spaces in publications to test and adjust visual aspects before using actual content.',
        'Adicionar Lookup': 'Add Lookup',
        'Adicione emails...': 'Add emails...'
    }
}

module.exports = en_us
